import React from 'react'
import '../../components/jobui/styles/globals.css'
import '../../components/jobui/styles/input.css'
import { ModuleInputConfig } from '../ModuleConfig/ModuleInputConfig'
import FileUploader, { FileUploaderDesign } from '../jobui/FileUploader'
import { UploadFileInfo } from '../jobui/UploadFileInfo'
import HomeFileUploaderMessageComp from './HomeFileUploaderMessageComp'
import * as Def from './HomeModuleDef'
import HomeModuleError, { HomeModuleErrorProps } from './HomeModuleError'
import HomeResult, { HomeResultProps } from './HomeResult'
import './styles/homemodule.css'

export interface ModuleContentProps extends HomeResultProps {
  fileSpec: string
  inputConfig: ModuleInputConfig
  inputId: string
  inputData: Record<string, UploadFileInfo>
  moduleStatus: Def.ModuleState

  moduleParamComp?: React.ElementType
  updateModuleParamList?: (newParam: Record<string, any>) => void

  setInputData: any
  addInputFile: any
  handleFileUploaderChange: any
  error: HomeModuleErrorProps | null
  resetStatus?: number

  restartButtonMsg?: string
  handleStartNewProcessing?: () => void
}

const ModuleContent = (props: ModuleContentProps) => {
  return (
    <div>
      {Def.isError(props.moduleStatus) && props.error ? (
        // Display an error message
        <HomeModuleError {...props.error} />
      ) : (
        <div
          className={`
            moduleContent
            ${Def.isProcessingCompleted(props.moduleStatus) ? 'result' : ''}`}
        >
          {/*
            - If the module is in idle status, ready to download:
              show the parameter component if it is given in the props.
            - If the module has completed a processing:
              display the result component.
          */}
          {Def.isProcessingCompleted(props.moduleStatus) ? (
            <HomeResult {...props} />
          ) : Def.isReadyToUpload(props.moduleStatus) ? (
            <>
              {props.moduleParamComp &&
                props.updateModuleParamList &&
                React.createElement(props.moduleParamComp, {
                  updateModuleParamList: props.updateModuleParamList,
                })}
            </>
          ) : null}

          {props.restartButtonMsg && props.handleStartNewProcessing &&
          Def.isProcessingCompleted(props.moduleStatus) ? (
            <div className="homeModuleRestart">
              <button
                className="homeModuleButton"
                type="button"
                onClick={props.handleStartNewProcessing}
              >
                <div className="homeModuleButtonText">
                  {props.restartButtonMsg}
                </div>
              </button>
            </div>
          ) : (
            <FileUploader
              mimeTypes={props.inputConfig.mimeTypeList}
              inputData={props.inputData}
              addInputFile={props.addInputFile}
              inputFileToUpload={props.inputData?.[props.inputId]}
              inputId={props.inputId}
              isMultipleSelection={false}
              parentClass={`
                FileUploaderInModuleContent
                fileUploader
                ${Def.isReadyToUpload(props.moduleStatus) ? 'idle' : 'processing'}
                ${props.processingResult ? 'with-result' : ''}
              `}
              showStatus={false}
              design={FileUploaderDesign.Full}
              statusChangeListener={props.handleFileUploaderChange}
              customMsgComp={
                Def.isReadyToUpload(props.moduleStatus) ? null : (
                  <HomeFileUploaderMessageComp
                    state={props.moduleStatus}
                    fileName={props.fileName}
                  />
                )
              }
              fullSecondaryMsg={props.fileSpec}
              uploadIcon={
                <img src="/icon/home-upload-cloud.svg" className="uploadIcon" />
              }
              // Display the upload icon if there is no result to display
              withUploadIcon={!Boolean(props.processingResult)}
              resetStatus={props.resetStatus}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default ModuleContent
